export const MOBILE_MENU = 'MOBILE_MENU'
export const ACTIVEMENU = 'ACTIVEMENU'
export const USER_ROLE = 'USER_ROLE'
